<template>
  <section class="section section2m">
    <div class="section-wrap-m">
      <div class="s2-top ">
            <h2 class="s2-title">{{$t("home.s2_1")}}</h2>
        <div class="clearfix">
          <div class="fl">
            <p class="s2-ps">{{$t("home.s2_2")}}</p>
          </div>
          <div class="fr num-more-box"> 
            <div @click="routerSkip('/about')" class="num-more clearfix"><span class="num-more-text">{{$t("common.more")}}</span><img src="@/assets/images/icon/more-point-right.png" class="more-icon"></div>
          </div>
        </div>
        <p class="s2-text" v-html='$t("home.s2_3")'></p>
      </div>
      <div class="s2-video">
        <div class="rela video section2-video" id="s2Video">
          <video id="video" v-show="videoPlay" class="full"  :src='$t("home.s2_6")' poster="@/assets/images/home/video-cover.jpg" controls="false"></video>
          <div class="abso full" :style="'top:0;left:0;background:url('+require('@/assets/images/home/video-cover.jpg')+') no-repeat center/cover'" v-show="!videoPlay"></div>
          <div class="abso video-btn" id="video-btn" @click="videoEvent" v-show="!videoPlay">
            <img src="@/assets/images/home/video-btn.png">
            <p>{{$t("home.s2_5")}}</p>
          </div>
          <!--<video id="video" ref="s2Video" class="full b-000" src="http://img.sensfoot.sdh5.com/media/video.mp4" poster="@/assets/images/tech/video.jpg" controls="false"></video>-->
          <!--<div class="abso full" :style="'top:0;left:0;background:url('+require('@/assets/images/home/video-cover.jpg')+') no-repeat center/cover'" v-show="!videoPlay"></div>-->
          <!--<div class="abso video-btn" id="video-btn" @click="videoEvent" v-show="!videoPlay">-->
            <!--<img src="@/assets/images/public/video-btn.png">-->
            <!--<p>了解SensFoot</p>-->
          <!--</div>-->
        </div>
        <!--<video id="s2Video" ref="s2Video" class="video-js vjs-polyzor-skin" controls preload="auto">-->
          <!--<source :src="videoSrc" type="video/mp4">-->
        <!--</video>-->
      </div>
      <div class="s2-bottom">
        <div class="s2-bottom-row">
          <div class="num-box" v-for='(item,index) in $t("home.s2_4")' v-if="index<3">
            <div class="num-title"><span>{{item.t1}}</span><i>{{item.t2}}</i></div>
            <div class="num-desc">{{item.t3}}</div>
          </div>

        </div>
        
      </div>
    </div>
  </section>
</template>

<script>
    import { IsPC } from '@/utils/autoScale'
  export default {
    name: 'homeSection2m',
    data () {
      return {
          videoPlay:false,
        videoSrc: "http://img.sensfoot.sdh5.com/media/video.mp4"
      }
    },
    created () {
      this.getList()
    },
    mounted () {
        var _this=this
      this.initVideo()
        if(!IsPC()){
            document.getElementById("video").addEventListener("pause",function(){
                // console.log(666666666666)
                _this.videoPlay=false
            },false)
            document.getElementById("video").addEventListener("play",function(){
                // console.log(7777777777)
                _this.videoPlay=true
            },false)
        }
    },
    methods: {
      getList() {

      },
      initVideo() {
        // this.$refs.s2Video["disablePicturePicture"] = true
      },
        videoEvent(){
            this.videoPlay=true
            document.getElementById("video").play()
            document.getElementById("video-btn").style.display="none"
        }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section2m
    padding-bottom 1rem;background-color #fafafa;text-align:justify;
  .s2-top
    padding .9rem 0 .6rem 0
  .s2-title
    font-size .4rem;color $standardColor
  .s2-ps
    margin .13rem 0 .26rem 0;font-size .26rem;color $standardColor
  .s2-text
    font-size .26rem;line-height .45rem;color #595757
  .s2-bottom-row
    display table;width: 100%;height:2.3rem;background:#fff;border-bottom 1px solid #e5e5e5
  .num-box
    display table-cell;vertical-align middle;text-align center;border-left 1px solid #e5e5e5;border-right 1px solid #e5e5e5;
  .num-box+.num-box
    border-left 1px solid transparent
  .s2-bottom-row+.s2-bottom-row .num-box
    border-top 1px solid transparent
  .num-more-box
    position relative;font-size:.24rem;color:#595757;border-left:0
    .num-more
      display block;width: 1.5rem;height: .5rem;border-bottom .02rem solid #666666;text-align left;line-height .48rem
      .more-icon
        abso();top 0;bottom 0;right 0;margin: auto;width: .32rem;height: .22rem;
  .num-title span
    font-size .4rem;color #333
  .num-title i
    font-size .2rem;color #333
  .num-desc
    margin-top .2rem;font-size .2rem;color #666666
  #s2Video
    width: 100%;height: 4.68rem
</style>
